module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_01@2x-29b3793faaead54178b426eb03e7ae2d.webp";